import React from "react";
import Billing from "../../components/user-profile-lite/Billing";
import "./ProfileBilling.scss";

/** Lovable chrome wrapper; prod Billing behavior unchanged. */
const BillingPanel = () => (
  <div className="profile-billing">
    <Billing />
  </div>
);

export default BillingPanel;
